import { render, staticRenderFns } from "./activity-dreaming.vue?vue&type=template&id=c08270fe&scoped=true&"
import script from "./activity-dreaming.vue?vue&type=script&lang=js&"
export * from "./activity-dreaming.vue?vue&type=script&lang=js&"
import style0 from "./activity-dreaming.vue?vue&type=style&index=0&id=c08270fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08270fe",
  null
  
)

export default component.exports